import React, { useContext, useEffect } from "react";
import { Box, SimpleGrid } from "@chakra-ui/react";
import MerchTable from "views/admin/merch/components/MerchTable";
import { columnsData } from "views/admin/merch/variables/columnsData";
import { AppContext } from "contexts/AppContext";

export default function Merch() {
  const { merchItemData, fetchMerchItemData } = useContext(AppContext);
  useEffect(() => {
    fetchMerchItemData();
  }, []);

  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <SimpleGrid
        mb="20px"
        columns={{ sm: 1, md: 1 }}
        spacing={{ base: "20px", xl: "20px" }}
      >
        <MerchTable columnsData={columnsData} tableData={merchItemData} />
      </SimpleGrid>
    </Box>
  );
}
